// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: space-between;
}

.left-side {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right-side {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right-side img {
  max-width: 100%;
  height: auto;
}

/* Media query for small screens */
@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }

  .left-side, .right-side {
    width: 100%;
  }

  .right-side {
    display: none; /* Hide the right-side content */
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa,EAAE,gCAAgC;EACjD;AACF","sourcesContent":[".login-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.left-side {\r\n  width: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.right-side {\r\n  width: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.right-side img {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n/* Media query for small screens */\r\n@media (max-width: 768px) {\r\n  .login-container {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .left-side, .right-side {\r\n    width: 100%;\r\n  }\r\n\r\n  .right-side {\r\n    display: none; /* Hide the right-side content */\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
